import { useTheme } from 'styled-components'
import * as S from '../styles'
import { ProductStatusEnum, SalesReceivementProduct } from '../../../ReceivementTypes'
import { ReceivementProductWrapper } from '../../ReceivementProductWrapper'
import { measureUnit, NumberFmt } from 'src/utils'
import { TableBody } from 'src/components/TableComponents'
import { WrongProductTableRow } from './WrongProductTableRow'
import notes from 'src/assets/images/other-images/notes.svg'
import check from 'src/assets/images/other-images/check.svg'
import { useObservationModal } from 'src/features/receivement/pages/ReceivementPurchase/hooks/useObservationModal'
import { useSelector } from 'react-redux'
import { selectSalesOverview } from 'src/features/receivement/ReceivementSelectors'

interface Props {
  product: SalesReceivementProduct
}

const WrongProductTable = ({ product }: Props) => {
  const theme = useTheme()
  const batch = product.batches[0]
  const salesOverview = useSelector(selectSalesOverview)

  const { openObservationModal, ObservationModalComponent } = useObservationModal({ id: batch.idsBatch[0], productObservation: product.observation, wrongProduct: true })

  const getDifference = () => {
    const value = batch.totalQuantity
    const prefix = value > 0 ? '+' : ''
    const color = value > 0 ? theme.colors.confirm : value < 0 ? theme.colors.red : 'inerit'

    return <S.Text style={{ color }}><NumberFmt prefix={prefix} value={value} sufix={`${measureUnit(product.isKg)}`} /></S.Text>
  }

  const getTotal = () => <NumberFmt value={batch.totalQuantity} sufix={`${measureUnit(batch.measureUnit.isKg)}`} />

  return (
    <ReceivementProductWrapper status={ProductStatusEnum.WRONG}>
      <S.Table>
        <S.TableHeader
          columnInformation={[
            { columnName: 'Produto' },
            { columnName: 'Anotações' },
          ]}
          flexColumns={[
            1,
            0.1,
          ]}
        />
        <TableBody>
          <S.TableBodyRow key={batch.idsBatch.toString()} backgroundColor={theme.colors.white}>
            <S.TableBodyCell flex={1}>{product.productDescription} {product.productCode && `Modelo: ${product.productCode}`}</S.TableBodyCell>
            <S.TableBodyCell flex={0.1}>
              <S.Button onClick={() => openObservationModal()}>
                {product.observation
                  && (
                  <S.ImageContainer>
                    <S.ImageCheck src={check} />
                  </S.ImageContainer>
                  )}
                <S.Image src={notes}/>
              </S.Button>
            </S.TableBodyCell>
          </S.TableBodyRow>
        </TableBody>
        <S.TableHeader
          backgroundColor={theme.colors.gray}
          columnInformation={[
            { columnName: 'Qtd. Recebida' },
            { columnName: 'Qtd. Avariada' },
            { columnName: 'Qtd. Útil' },
            { columnName: 'Data Validade' },
            { columnName: 'Motivo Avaria' },
            { columnName: 'Ação' },
            { columnName: 'Qtd. a Aceitar' },
          ]}
          flexColumns={[
            1,
            1,
            1,
            1,
            1,
            1.5,
            1,
          ]}
        />
        <TableBody>
          <WrongProductTableRow
            batch={batch}
          />
        </TableBody>
        <S.TableHeader
          backgroundColor={theme.colors.gray}
          columnInformation={[
            { columnName: 'Total Recebido' },
            { columnName: 'Total Avariado' },
            { columnName: 'Total Útil' },
            { columnName: 'Total Esperado' },
            { columnName: 'Diferença (Útil - Esperado)' },
            { columnName: 'Total Aceito' },
          ]}
          flexColumns={[
            1,
            1,
            1,
            1,
            1.8,
            1,
          ]}
        />
        <S.TableBody>
          <S.TableBodyRow backgroundColor={theme.colors.white}>
            <S.TableBodyCell flex={1}>{getTotal()}</S.TableBodyCell>
            <S.TableBodyCell flex={1}>
              <NumberFmt value={product.damageQuantity} sufix={measureUnit(product.isKg)} />
            </S.TableBodyCell>
            <S.TableBodyCell flex={1}>
              <NumberFmt value={batch.totalQuantity - batch.damageQuantity} sufix={measureUnit(product.isKg)} />
            </S.TableBodyCell>
            <S.TableBodyCell flex={1}>
              <NumberFmt value={0} sufix={measureUnit(product.isKg)} />
            </S.TableBodyCell>
            <S.TableBodyCell flex={1.8}>{getDifference()}</S.TableBodyCell>
            <S.TableBodyCell flex={1}>
              <S.StatusQuantity
                backgroundColor={salesOverview?.allowPartialReturn && !salesOverview.allowBreakUnitOnInvoiceReturn ? theme.colors.green : ''}
                color={theme.colors.darkGray}
                data-testid='valid-quantity'
              >
                {0}
              </S.StatusQuantity>
            </S.TableBodyCell>
          </S.TableBodyRow>
        </S.TableBody>
      </S.Table>

      {ObservationModalComponent}
    </ReceivementProductWrapper>
  )
}

export { WrongProductTable }
